<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Interventi attivati o da attivare per l'utente" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Nomina amministratore di sostegno: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.nominaAmministrativa }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.nominaAmministrativa" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Esenzioni: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.esenzioni }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.esenzioni" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Terapia farmacologica a carico familiare: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.terapiaFarmacologica }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.terapiaFarmacologica" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Ausili: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.ausili }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.ausili" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Pannoloni: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.pannoloni }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.pannoloni" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Cateteri: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.cateteri }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.cateteri" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Stomie: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.stomie }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.stomie" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Nutrizione: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.nutrizione }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.nutrizione" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Strisce reattive: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.strisceReattive }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.strisceReattive" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Ossigenoterapia: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.ossigenoterapia }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.ossigenoterapia" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Fornitura farmaci a carico dei familiari: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.fornituraFarmaci }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.fornituraFarmaci" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Invalidità civile: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.invaliditaCivile }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.invaliditaCivile" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Accompagnamento: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.accompagnamento }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.accompagnamento" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Legge 104/92: <span style="color: red">*</span></label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.centoquattro }}</span>
                        <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonDataInterventiSocioAssistenziale.centoquattro" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" value-field="value" text-field="text"></b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data"> Altro:</label>
                        <span v-if="isReadOnly">{{ jsonDataInterventiSocioAssistenziale.altro }}</span>
                        <b-form-textarea v-else v-model="jsonDataInterventiSocioAssistenziale.altro" :readonly="isReadOnly" max-rows="10" rows="7"></b-form-textarea>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },
    data() {
        return {
            pathResourceInterventiSocioAssistenziale: "/rsaschedavalutazioneinterventisocioassistenziali",
            jsonDataInterventiSocioAssistenziale: {
                idAccettazione: null,
                nominaAmministrativa: null,
                esenzioni: null,
                terapiaFarmacologica: null,
                ausili: null,
                pannoloni: null,
                cateteri: null,
                stomie: null,
                nutrizione: null,
                strisceReattive: null,
                ossigenoterapia: null,
                fornituraFarmaci: null,
                invaliditaCivile: null,
                accompagnamento: null,
                centoquattro: null,
                altro: null,
            },
            sinoOptions: [
                { value: null, text: "Seleziona valore", disabled: true },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$query.params.id;
        me.jsonDataInterventiSocioAssistenziale.idAccettazione = me.idAccettazione;
        if (me.idRisorsa !== null) {
            me.visualizzaInterventiSocioAssistenziale();
        }
        me.jsonDataInterventiSocioAssistenziale = {
            idAccettazione: me.idAccettazione,
            nominaAmministrativa: null,
            esenzioni: null,
            terapiaFarmacologica: null,
            ausili: null,
            pannoloni: null,
            cateteri: null,
            stomie: null,
            nutrizione: null,
            strisceReattive: null,
            ossigenoterapia: null,
            fornituraFarmaci: null,
            invaliditaCivile: null,
            accompagnamento: null,
            centoquattro: null,
            altro: null,
        };
    },
    watch: {
        jsonDataInterventiSocioAssistenziale: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        visualizzaInterventiSocioAssistenziale() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResourceInterventiSocioAssistenziale + "/" + me.idRisorsa;
            UtilityMixin.methods.restCallGet(path, null, me.loadDataInterventiSocioAssistenzialeSuccess, me.loadDataInterventiSocioAssistenzialeError);
        },
        loadDataInterventiSocioAssistenzialeSuccess(response) {
            let me = this;
            me.jsonDataInterventiSocioAssistenziale = response.data.data;
        },
        loadDataInterventiSocioAssistenzialeError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
